import { adminFetch, adminMutate, adminRequest } from '../../../utils/adminApi';
import { adminRoadmapService, type AdminRoadmapItem } from '../../../services/adminRoadmapService';
import { PRODUCT_UPDATES_API, type ProductUpdate, type ProductUpdateStatus } from './productUpdatesLogic';

interface Envelope<T> {
  success: boolean;
  data: T;
  message: string;
}

type Body = Record<string, unknown>;

async function unwrap<T>(p: Promise<Envelope<T>>): Promise<T> {
  return (await p).data;
}

export const ProductUpdatesAdmin = {
  list: (status: ProductUpdateStatus | '' = '') =>
    unwrap(adminFetch<Envelope<ProductUpdate[]>>(`${PRODUCT_UPDATES_API}${status ? `?status=${status}` : ''}`)),
  get: (id: string) => unwrap(adminFetch<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}`)),
  create: (body: Body) => unwrap(adminMutate<Envelope<ProductUpdate>>(PRODUCT_UPDATES_API, 'POST', body)),
  edit: (id: string, body: Body) =>
    unwrap(adminMutate<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}`, 'PATCH', body)),
  approve: (id: string) => unwrap(adminMutate<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}/approve`, 'POST')),
  publish: (id: string) => unwrap(adminMutate<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}/publish`, 'POST')),
  archive: (id: string) => unwrap(adminMutate<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}/archive`, 'POST')),
  postToBlog: (id: string) => unwrap(adminMutate<Envelope<ProductUpdate>>(`${PRODUCT_UPDATES_API}/${id}/blog`, 'POST')),
  shippedRoadmapItems: async (): Promise<AdminRoadmapItem[]> =>
    (await adminRoadmapService.list({ status: 'shipped', include_shipped: true, limit: 200 })).items,
  uploadHero: async (file: File): Promise<string> => {
    const form = new FormData();
    form.append('file', file);
    const res = await adminRequest('/api/admin/blog/media/upload', { method: 'POST', body: form });
    const json = (await res.json()) as Envelope<{ url: string }>;
    return json.data.url;
  },
};
